/* @ngInject */
export default function changePasswordFactory($http, HPConfig) {
    const changePasswordEnabled = false;
    const userObj = {};
    const statusMessage = '';
    const isPasswordDirty = false;

    return {
        changeUserPassword,
        requestRecoverPasswordEmail,
        changePasswordEnabled,
        userObj,
        statusMessage,
        isPasswordDirty,
    };

    function changeUserPassword(data) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/Auth`,
            method: 'POST',
            data,
        });
    }

    function requestRecoverPasswordEmail(email) {
        let passwordResetUrl;
        let data;
        passwordResetUrl = `${HPConfig.heroProApi}Login/SendPasswordRecoveryEmail`;
        data = {
            Email: email,
        };
        return $http({
            url: passwordResetUrl,
            method: 'POST',
            data,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/controls/changePassword/changePasswordFactory.js